<!-- <span class="status {{ hubConnectionStatus.toLowerCase() }}"
      [matTooltip]="'Live update ' + hubConnectionStatus.toLowerCase()"
      matTooltipPosition="after">
</span> -->
